<template>
  <default-dialog
    v-model="value"
    width="85%"
    @accepted="accepted($event)"
    @closing="closing($event)"
    :label_accept="label_accept"
  >

    <template #header>
      {{ header_txt }}
    </template>

    <template #content>
      <v-container grid-list-md>
        <v-layout wrap>

          <v-flex lg10 md8 sm12 xs12>
            <v-text-field
              v-model="inputs.name" placeholder="Name"
              outlined dense hide-details>
            </v-text-field>
          </v-flex>

          <v-flex lg2 md4 sm12 xs12>
            <v-text-field
              v-model="inputs.state" placeholder="State"
              outlined dense hide-details>
            </v-text-field>
          </v-flex>

          <v-flex lg6 md6 sm12 xs12>
            <v-select
              v-model="inputs.project" placeholder="Project"
              :items="project_items"
              item-value="id" item-text="name"
              outlined dense hide-details>
            </v-select>
          </v-flex>

          <v-flex lg6 md6 sm12 xs12>
            <v-select
              v-model="inputs.panel" placeholder="Panel"
              :items="panel_items"
              item-value="value" item-text="text"
              outlined dense hide-details>
            </v-select>
          </v-flex>

          <v-flex lg12 md12 sm12 xs12>
            <v-text-field
              v-model="inputs.filepath" placeholder="File path"
              outlined dense hide-details>
            </v-text-field>
          </v-flex>

          <v-flex lg12 md12 sm12 xs12>
            <v-textarea
              v-model="inputs.notes" placeholder="Notes" rows="3"
              outlined dense hide-details>
            </v-textarea>
          </v-flex>

          <v-flex lg12 md12 sm12 xs12>
            <v-textarea
              v-model="inputs.settings" placeholder="Settings" rows="9"
              outlined dense hide-details>
            </v-textarea>
          </v-flex>


        </v-layout>
      </v-container>

    </template>

  </default-dialog>
</template>

<script>

	import {mapActions, mapGetters, mapState} from 'vuex'
	import {
		VContainer, VLayout, VRow, VCol, VFlex,
		VTextField, VTextarea, VSelect,
	} from 'vuetify'

	export default {
		name: 'analysis-props-dialog',

		components: {
			VContainer, VLayout, VRow, VCol, VFlex,
			VTextField, VTextarea, VSelect,
		},

		data: function () {
			return {
				inputs: {
					id: null,
					name: null,
					notes: null,
					settings: null,
					state: null,
					state_dt: null,
					filepath: null,
					panel: null,
					project: null,
				}
			}
		},

		props: {
			analysis: {type: Object, default: () => null,},

			value: {type: Boolean, default: false,},
		},

		watch: {
			analysis: function () {
				for (let key in this.inputs) {
					this.inputs[key] = this.analysis != null ? this.analysis[key] : null
				}
			},
		},

		computed: {
			...mapState({
				'store_panels': (state) => state.panels.panels,
			}),

			...mapGetters({
				store_project_list: 'projects/project_list'
			}),

			header_txt: function () {
				return "Analysis"
			},

			label_accept: function () {
				return this.analysis === null ? "Create" : "Update"
			},

			project_items: function () {
				return this.store_project_list
			},

			panel_items: function () {
				const panels = this.store_panels
				// Создадим список анонимных объектов, и его еще отсортировать надо.
				// У panels ключ - short
				return panels.list_ids.map((panel_short) => ({value: panels.objects[panel_short].id, text: panel_short}))
			},
		},

		mounted() {
			// здесь нужно загрузить списки, нужные для диалога
			this.progress_begin({message: "Preparing...",})
			Promise.all([
				// вызываем загрузку данных
				this.fetch_project_list(),
				this.fetch_panel_list(),
			])
				.then(() => {

				})
				.catch((error) => {
					this.message_add(error)
				})
				.finally(() => {
					this.progress_end()
				})
		},

		methods: {
			...mapActions({
				progress_begin: 'progress/begin',
				progress_end: 'progress/end',
				message_add: 'message/add',

				fetch_project_list: 'projects/project_list',
				fetch_panel_list: 'panels/update'
			}),

			accepted: function (event) {
				event.inputs = this.inputs
				this.$emit('accepted', event)
			},

			closing: function (event) {
				this.$emit('closing', event)
			}
		},
	}
</script>

<style scoped>

</style>